import CustomError from "./CustomError";

export default error => {
  if (error.response) {
    throw new CustomError(error.response.data);
  } else {
    throw new CustomError({ code: "EXCEPTION", message: error.message });
  }
};
